import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import Lightbox from '../../../ui/lightbox/Lightbox';
import { ReferenceToElement } from '../../../ui/accessibility';
import westlakeLogo from '../../../assets/card-apply/icons/westlake-logo@2x.png';
import westlakeLogoSmall from '../../../assets/card-apply/icons/westlake-logo.png';
import sunbitLogo from '../../../assets/logoWithTextBlue.svg';
import sunbitCardLogo from '../../../assets/card-apply/icons/sunbitcard.web.cardbackg.png';
import Button from '../agreeButton/AgreeButton';

// tslint:disable-next-line:variable-name
const SWelcomerPopup = styled.section(({ theme }) => `
  display: flex;
  align-items: center;
  background-color: #f1f9fe;
  position: relative;
  box-shadow: 0 0 28px 16px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  &:focus { outline: 0px transparent }
  @media only screen and (max-width: 1600px) {
    height: 750px;
  }
  @media only screen and ${theme.device.max.laptop} {
    width: 90%;
  }
  @media only screen and ${theme.device.max.mobileL} {
    width: 100%;
    height: 100%;
  }
`);

const SInnerDiv = styled.section(({ theme }) => `
  background-color: #f1f9fe;
  margin: 36px 0 54px 0;
  padding-top: 30px;
  @media only screen and (max-width: 1600px) {
    padding-top: 15px;
    height: 90%;
    width: 100%;
  }
  @media only screen and ${theme.device.max.laptop} {
    height: 85%;
  }
  @media only screen and ${theme.device.max.mobileL} {
    height: 100%;
  }
`);

const SUpperLogos = styled.div(({ theme }) => `
  display: flex;
  justify-content: center;
  z-index: 1;
  align-items: center;
  @media only screen and ${theme.device.max.mobileL} {
    margin-top: 25px;
  }
`);

const WestlakeLogoImg = styled.img(({ theme }) => `
  z-index: 1;
  width: 175px;
  height: 57px;
  margin-left: 400px;
  @media only screen and ${theme.device.max.laptop} {
    margin-left: 300px;
  }
  @media only screen and ${theme.device.max.mobileL} {
    margin-left: 40px;
  }
  @media only screen and ${theme.device.max.mobileS} {
    width: 157px;
    margin-left: 20px;
    height: 51px;
  }
`);

const SunbitLogoImg = styled.img(({ theme }) => `
  width: 127px;
  height: 36px;
  z-index: 1;
  @media only screen and ${theme.device.max.mobileS} {
    width: 114px;
    height: 32px;
  }
`);

const SunbitCardLogoImg = styled.img(({ theme }) => `
  left: auto;
  right: auto;
  position: relative;
  z-index: 0;
  width: 486px;
  height: 412px;
  margin-top: -100px;
  @media only screen and ${theme.device.max.mobileL} {
    width: 372px;
    height: 315px;
    margin-top: -40px;
  }
  @media only screen and ${theme.device.max.mobileM} {
    width: 335px;
    height: 283px;
    margin-top: -80px;
  }
  /* iPhone X */
  @media ${theme.device.max.mobileM} and (min-height: 800px) {
    margin-top: -20px;
  }
`);

const SBottomLogos = styled.div(() => `
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 0;
  align-items: center;
`);

const SWelcomeTextContainer = styled.div(({ theme }) => `
  text-align: center;
  line-height: 28px;
  margin: 55px 100px 40px 100px;
  font-size: 28px;
  z-index: 1;
  color: #14146c;
  position: relative;
  @media only screen and (max-width: 1600px) {
    margin: 35px 40px 40px 40px;
  }
  @media only screen and ${theme.device.max.mobileL} {
    margin: 30px 20px 10px 20px;
    font-size: 20px;
  }
  @media only screen and ${theme.device.max.mobileM} {
    margin: 40px 20px 20px 20px;
    line-height: 20px;
  }
  @media only screen and ${theme.device.max.mobileS} {
    font-size: 16px;
    line-height: 16px;
  }
`);

const SWelcomeDisclaimerTextContainer = styled.div(({ theme }) => `;
  margin: 45px 140px 20px 190px;
  align-self: center;
  text-align: center;
  color: #002169;
  position: relative;
  z-index: 1;
  font-size: 12px;
  flex-wrap: nowrap;
  @media only screen and ${theme.device.max.laptop} {
    margin: 15px 40px 15px 40px;
  }
  @media only screen and ${theme.device.max.mobileL} {
    margin: 30px 20px 10px 20px;
  }
  @media only screen and ${theme.device.max.mobileM} {
    margin: 30px 20px 10px 20px;
  }
  /* iPhone X */
  @media ${theme.device.max.mobileM} and (min-height: 800px) {
    margin: 50px 20px 10px 20px;
  }
  @media only screen and ${theme.device.max.mobileS} {
    margin: 10px 20px 10px 20px;
  }
`);

const SBoldText = styled.p(({ theme }) => `;
  font-weight: bold;
  color: #002169;
  z-index: 1;
  @media only screen and ${theme.device.max.mobileL} {
    margin-left: auto;
    margin-right: auto;
  }
`);

const SButton = styled(Button as any)(({ theme }) => `;
  margin-right: auto;
  margin-left: auto;
  margin-top: -60px;
  z-index: 1;
  background-color: #ff9900;
  font-weight: bold;
  color: #14146c;
  box-shadow: 0.9px 1.8px 2.2px 0.8px rgba(26, 27, 31, 0.4);
  @media only screen and ${theme.device.max.tablet} {
    width: 255px;
    height: 44px;
  }
  @media only screen and ${theme.device.max.mobileL} {
    margin-top: -40px;
  }
  @media only screen and ${theme.device.max.mobileS} {
    margin-top: -45px;
  }
`);

export interface IWelcomerPopup {
  className?: string;
  onClose?: () => void;
}

// tslint:disable-next-line:variable-name
const WelcomerPopup: React.FC<IWelcomerPopup> = (props) => {
  const popupContainer = React.useRef<HTMLElement>(null);

  const isMobileMedium = useMediaQuery({
    query: '(max-width: 375px)',
  });

  const isTabletOrLower = useMediaQuery({
    query: '(max-width: 1024px)',
  });

  React.useEffect(() => {
    if (popupContainer && popupContainer.current) {
      popupContainer.current.focus();
    }
  }, []);

  const handleClose = React.useCallback(() => {
    if (props.onClose !== undefined) {
      props.onClose();
    }
  }, [props.onClose]);

  return (
    <Lightbox>
      <SWelcomerPopup data-at="welcomerPopup" id="dialogModalElement" tabIndex={0} ref={popupContainer} className={props.className}>
        <SInnerDiv data-at="welcomerPopup-InnerDiv">
          <SUpperLogos data-at="welcomerPopup-UpperLogos">
            <SunbitLogoImg data-at="welcomerPopup-SunbitLogo" src={sunbitLogo} />
            <WestlakeLogoImg data-at="welcomerPopup-WestlakeLogo" src={isMobileMedium ? westlakeLogoSmall : westlakeLogo} />
          </SUpperLogos>
          { isTabletOrLower
            ? <SWelcomeTextContainer data-at="welcomerPopup-MainText"><SBoldText>Welcome!</SBoldText>With the Sunbit Card you&apos;re on your<br />way to buying whatever, whenever,<br />and splitting your balance<br />into 36 payments*.</SWelcomeTextContainer>
            : <SWelcomeTextContainer data-at="welcomerPopup-MainText"><SBoldText>Welcome!</SBoldText>With the Sunbit Card you&apos;re on your way to buying<br />whatever, whenever, and splitting your balance<br />into 36 payments*.</SWelcomeTextContainer> }
          <SBottomLogos data-at="welcomerPopup-BottomLogo">
            <SunbitCardLogoImg src={sunbitCardLogo} />
          </SBottomLogos>
          <SButton dataAt="continueButton" onClick={handleClose}>Continue</SButton>
          { isTabletOrLower
            ? (
              <SWelcomeDisclaimerTextContainer data-at="welcomerPopup-DisclaimerText">
                *Subject to approval. If you have no purchase-related transactions on your account (and certain other events do not occur), you can generally
                pay off your balance in 36 months by timely making the required minimum payment due each billing cycle.
                The Sunbit Card is issued by Transportation Alliance Bank, Inc., dba TAB Bank, pursuant to a license from Visa U.S.A. Inc.
                Use of the card is subject to the cardholder agreement.
              </SWelcomeDisclaimerTextContainer>
            )
            : (
              <SWelcomeDisclaimerTextContainer data-at="welcomerPopup-DisclaimerText">
                *Subject to approval. If you have no purchase-related transactions on your account (and certain other events do not occur),<br />
                you can generally pay off your balance in 36 months by timely making the required minimum payment due each billing cycle.<br />
                The Sunbit Card is issued by Transportation Alliance Bank, Inc., dba TAB Bank, pursuant to a license from Visa U.S.A. Inc.<br />
                Use of the card is subject to the cardholder agreement.
              </SWelcomeDisclaimerTextContainer>
            ) }

        </SInnerDiv>
        <ReferenceToElement querySelector="#dialogModalElement" />
      </SWelcomerPopup>
    </Lightbox>
  );
};

export default WelcomerPopup;
